import { Component, Input, OnInit } from "@angular/core";
import { LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure } from "@ptl/account-management";
import { RedirectService } from "src/app/angular-elements/shared/services/redirect.service";
import { ReducerUtilityService } from "src/app/shared/utility-services/reducer-utility.service";
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-marcom-sso',
    templateUrl: './marcom-sso.component.html',
    styleUrls: ['./marcom-sso.component.scss'],
    standalone: false
})
export class MarcomSSOComponent implements OnInit {

    @Input() marcomLabel: string;
    
    userId = '';

    constructor(
        private reducerUtilityService: ReducerUtilityService,
        private redirectService: RedirectService
    ) { }

    ngOnInit() {
        const loginInfo: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
        this.userId = loginInfo.userId;
    }

    submitMarcomSSOForm() {
        let destinationURL = "marcomSSO";
        let target = "https://" + environment.external.vendors.agentCubeUrl;
        let postParams = { userName: this.userId, destinationURL: destinationURL, target }
        this.redirectService.post(postParams);
    }

}